module.exports = __webpack_public_path__ + "img/jeans1.a4999a50.svg";